module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_5.05bdbdf3b639bac7a2d6136076b1588e.png";